import { z } from 'zod';

export const CC_WORKFLOW_STATUSES = ['active', 'archived'] as const;
export type CCWorkflowStatus = typeof CC_WORKFLOW_STATUSES[number];

export const ZCCWorkflow = z.object({
  id: z.number(),
  name: z.string(),
  company_id: z.number(),
  description: z.string().optional(),
  major_version: z.number().optional(),
  minor_version: z.number().optional(),
  matrix_id: z.string().optional(),
  status: z.enum(CC_WORKFLOW_STATUSES).optional(),
});

export const ZCCWorkflowLink = ZCCWorkflow.extend({
  is_linked: z.boolean(),
  qualio_managed: z.boolean().optional(),
});

export type CCWorkflow = z.infer<typeof ZCCWorkflow>;
export type CCWorkflowLink = z.infer<typeof ZCCWorkflowLink>;

export const isArchivedWorkflow = (wf: CCWorkflow | CCWorkflowLink): boolean => wf.status === 'archived';

export const getActiveMatrixIds = (wfs: CCWorkflowLink[]): string[] =>
  wfs.filter((wf) => !isArchivedWorkflow(wf)).flatMap((wf) => (wf.matrix_id ? [wf.matrix_id] : []));
